import React from 'react';
import { SearchImportBar, ImportResultModal, LoadingBar } from '../../../components/common';
import { ImportResult } from './types';
import '../../../components/common/CRMForm.css';
import './CrsDataImportForm.css';

interface CrsDataImportFormProps {
  selectedFiles: File[];
  onSelectFiles: (files: File[]) => void;
  onImport: () => void;
  importResult: ImportResult | null;
  onCloseResult: () => void;
  error: string | null;
  globalLoading: boolean;
  loadingMessage: string;
}

const CrsDataImportForm: React.FC<CrsDataImportFormProps> = ({
  selectedFiles,
  onSelectFiles,
  onImport,
  importResult,
  onCloseResult,
  error,
  globalLoading,
  loadingMessage
}) => {
  return (
    <>
      <div className="form">
        <div className="form-header">
          <h2>CRS Data Import</h2>
        </div>
        <p>
          Choose a folder that contains one or more CRS Data property report PDFs.
          Each report creates or reuses a Prospect contact with mailing and rental addresses.
        </p>

        <div className="app-form-group">
          <label className="app-form-label" htmlFor="crs-import-directory">PDF folder</label>
          <div className="crs-data-import-picker">
            <SearchImportBar
              accept=".pdf,application/pdf"
              directory
              multiple
              loading={globalLoading}
              title="Choose a folder of CRS Data PDFs"
              onImportFiles={onSelectFiles}
            />
            <span id="crs-import-directory">
              {selectedFiles.length === 0
                ? 'No PDFs selected'
                : `${selectedFiles.length} PDF${selectedFiles.length === 1 ? '' : 's'} selected`}
            </span>
          </div>
        </div>

        {selectedFiles.length > 0 && (
          <ul className="crs-data-import-files">
            {selectedFiles.map((file) => (
              <li key={`${file.name}-${file.size}-${file.lastModified}`}>{file.name}</li>
            ))}
          </ul>
        )}

        <div className="app-form-actions">
          <button
            type="button"
            className="app-btn app-btn-primary"
            onClick={onImport}
            disabled={selectedFiles.length === 0 || globalLoading}
          >
            Import
          </button>
        </div>

        {error && <div className="app-error-message">{error}</div>}
      </div>
      <ImportResultModal
        isOpen={importResult !== null}
        processed={importResult?.processed || 0}
        notProcessed={importResult?.notProcessed || []}
        onClose={onCloseResult}
      />
      <LoadingBar isLoading={globalLoading} message={loadingMessage} />
    </>
  );
};

export default CrsDataImportForm;
